import { render, staticRenderFns } from "./TipIcon.vue?vue&type=template&id=329aff66&scoped=true&"
import script from "./TipIcon.vue?vue&type=script&lang=ts&"
export * from "./TipIcon.vue?vue&type=script&lang=ts&"
import style0 from "./TipIcon.vue?vue&type=style&index=0&id=329aff66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "329aff66",
  null
  
)

export default component.exports